<template>
<div>
  <my-header></my-header>
  
    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <b-breadcrumb>
          <b-breadcrumb-item :to="{name:'players_pendings'}">Mass pendings</b-breadcrumb-item>
        </b-breadcrumb>

        <h2>Mass pending {{massPendingId}}</h2>
        <router-view></router-view>
      </div>
    </div>
</div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'MassPending',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    massPendingId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Info',
          route: {name: 'mass_pending_info', params: {massPendingId: this.massPendingId}},
        },
        {
          title: 'Players',
          route: {name: 'mass_pending_players', params: {massPendingId: this.massPendingId}},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
  margin-bottom: 1rem;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
}
</style>
